import { Rutas } from '@/constants/rutas';
import BiwengerIcon from '../../icons/biwenger-icon';

export const NavigationFantasyBiwengerItems = [
    {
        title: 'Mercado Biwenger',
        shortTitle: 'Mercado Biwenger',
        path: Rutas.MERCADO_BIWENGER,
        id: 'mercado-biwenger',
        icon: <BiwengerIcon width={20} height={20} />,
    },
    {
        title: 'Puja Ideal Biwenger',
        shortTitle: 'Puja',
        path: Rutas.PUJA_FANTASY_BIWENGER,
    },
    {
        title: 'Estadísticas Biwenger',
        shortTitle: 'Estadísticas',
        path: Rutas.ESTADISTICAS_BIWENGER,
    },
    {
        title: 'Chollos Biwenger',
        shortTitle: 'Chollos',
        path: Rutas.CHOLLOS_FANTASY_BIWENGER,
    },
    {
        title: 'Puntuaciones por jornada',
        shortTitle: 'Puntuaciones',
        path: Rutas.PUNTUACIONES_BIWENGER_DIARIO_AS,
    },
];
